export const API_PREFIX = "/api";

export const API = {
  health: `${API_PREFIX}/health`,
  organizations: `${API_PREFIX}/orgs`,
  agents: `${API_PREFIX}/agents`,
  projects: `${API_PREFIX}/projects`,
  issues: `${API_PREFIX}/issues`,
  chats: `${API_PREFIX}/chats`,
  messenger: `${API_PREFIX}/messenger`,
  calendar: `${API_PREFIX}/calendar`,
  goals: `${API_PREFIX}/goals`,
  approvals: `${API_PREFIX}/approvals`,
  requests: `${API_PREFIX}/requests`,
  secrets: `${API_PREFIX}/secrets`,
  costs: `${API_PREFIX}/costs`,
  activity: `${API_PREFIX}/activity`,
  agentRuns: `${API_PREFIX}/agent-runs`,
  dashboard: `${API_PREFIX}/dashboard`,
  sidebarBadges: `${API_PREFIX}/sidebar-badges`,
  invites: `${API_PREFIX}/invites`,
  joinRequests: `${API_PREFIX}/join-requests`,
  members: `${API_PREFIX}/members`,
  admin: `${API_PREFIX}/admin`,
} as const;
